angular.module('env.data.models.baseModel', [])

    .config(function (restProvider, RepresentationModelFieldTypes) {
        restProvider.defineModel("BaseModel",
            {
                extend: ['IdModel'],
                fields: {
                    created: {
                        type: RepresentationModelFieldTypes.DATE
                    },
                    updated: {
                        type: RepresentationModelFieldTypes.DATE
                    },
                    version: {
                        type: RepresentationModelFieldTypes.INTEGER
                    },
                    data: {
                        type: RepresentationModelFieldTypes.DYNAMIC
                    }
                }
            }
        );
    })

;